import { render, staticRenderFns } from "./marketMyPurchase.vue?vue&type=template&id=2bba0aa1&scoped=true"
import script from "./marketMyPurchase.vue?vue&type=script&lang=js"
export * from "./marketMyPurchase.vue?vue&type=script&lang=js"
import style0 from "./marketMyPurchase.vue?vue&type=style&index=0&id=2bba0aa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba0aa1",
  null
  
)

export default component.exports